<template>
	<div>
		<div class="flex min-h-[calc(100vh-68px)] md:items-center">
			<nuxt />
			<ToastContainerComponent />
		</div>
		<FooterComponent />

		<PortalTarget name="tooltip-root" multiple />
	</div>
</template>

<script>
import ToastContainerComponent from '~/components/toast-container'
import FooterComponent from '~/components/footer'

export default {
	middleware: ['outdatedBrowser'],
	components: {
		FooterComponent,
		ToastContainerComponent
	}
}
</script>
